const headers = [
  {
    text: 'sale.sale_order-date',
    value: 'saleDate',
    width: '100px'
  },
  {
    text: 'sale.sale_customer-name',
    value: 'customerId',
    width: '110px'
  },
  {
    text: 'sale.sale_author',
    value: 'userId',
    width: '70px'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    width: '90px'
  },
  {
    text: 'sale.sale_status',
    value: 'status'
  }
]

const tableKey = 'saleId'

const productListHeaders = [
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'product.taxId',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '%'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_number-of-sales',
    value: 'quantity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_unit-price',
    value: 'price',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end',
    unit: '元'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end',
    unit: '元'
  },
  {
    text: 'sale.sale_exporter',
    value: 'exportSubjectFlg',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

const productListHeadersForEdit = [
  {
    text: 'sale.sale_status',
    value: 'product.disabledFlg',
    sortable: false,
    width: '6%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'product.taxId',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '%'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_number-of-sales',
    value: 'quantity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_unit-price',
    value: 'price',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end',
    unit: '元'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end',
    unit: '元'
  },
  {
    text: 'sale.sale_exporter',
    value: 'exportSubjectFlg',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

export default {
  headers,
  tableKey,
  productListHeaders,
  productListHeadersForEdit
}
